import months from '../const/months';
export function getPropsForActivityRow(item, onSelectActivity) {
    var description = item.description, transactionId = item.localTransactionId, transactionInfo = item.transactionInfo, type = item.type, createdDate = item.createdDate, postedDate = item.postedDate, amount = item.amount, status = item.status;
    var skuReferenceDetails = transactionInfo === null || transactionInfo === void 0 ? void 0 : transactionInfo.skuReferenceDetails;
    var pDate = postedDate ? new Date(postedDate) : new Date(createdDate);
    var mIndex = pDate.getMonth();
    var sMonth = months[mIndex] || '';
    var sDay = pDate.getDate() || '';
    var formattedDate = "".concat(sMonth, " ").concat(sDay);
    var onClick = function () { return onSelectActivity(transactionId); };
    var onKeyUp = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            onSelectActivity(transactionId);
        }
    };
    return {
        amount: amount,
        description: description,
        formattedDate: formattedDate,
        status: status,
        onClick: onClick,
        onKeyUp: onKeyUp,
        skuReferenceDetails: skuReferenceDetails,
        transactionId: transactionId,
        type: type
    };
}
export var isNotCanceledTransaction = function (status) {
    return status !== 'CANCELED';
};
export var isCanceledPaymentTransaction = function (status, type) {
    return (status === 'CANCELED' &&
        type === 'PAYMENT');
};
export var isNoErrorPurchaseOrCanceledPayment = function (_a) {
    var status = _a.status, type = _a.type, emptyDescription = _a.emptyDescription, isError = _a.isError;
    var isPurchase = type === 'PURCHASE' &&
        !emptyDescription &&
        !isError;
    var isCanceledPayment = status === 'CANCELED' &&
        type === 'PAYMENT' &&
        !isError;
    return isPurchase || isCanceledPayment;
};
//# sourceMappingURL=activity.js.map